<template>
  <div id="app">
    <div class="app-container">
      <!-- 顶部导航栏 -->
      <Header
        title="RippleX"
        :username="userInfo?.username || '用户'"
        :userAvatar="avatarBase64 || userInfo?.avatar || 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'"
        :isLoggedIn="isLoggedIn"
        @toggle-sidebar="onToggleSidebar"
        @command="onHeaderCommand"
      />

      <div class="app-main">
        <!-- 左侧侧边栏 -->
        <Sidebar
          :activeMenu="activeMenu"
          @select="onMenuSelect"
        />

        <!-- 主内容区 -->
        <main class="app-content">
          <div class="content-container">
            <router-view></router-view>
          </div>
          <!-- 底部Footer -->
          <footer class="app-footer">
            <span>RippleX © 2026 果动数智科技 | <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">京ICP备18017034号-2</a></span>
          </footer>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Header from './components/Header.vue'
import Sidebar from './components/Sidebar.vue'
import { getAvatar } from './api/user'

export default {
  name: 'App',
  components: {
    Header,
    Sidebar
  },
  data() {
    return {
      activeMenu: '/dashboard',
      avatarBase64: ''
    }
  },
  computed: {
    ...mapState('app', ['sidebarCollapsed']),
    ...mapState('user', ['userInfo', 'isLoggedIn'])
  },
  watch: {
    isLoggedIn(newVal) {
      if (newVal) {
        this.loadAvatar()
      } else {
        this.avatarBase64 = ''
      }
    }
  },
  mounted() {
    // 监听路由变化，更新激活菜单
    this.$watch('$route.path', (newPath) => {
      this.activeMenu = newPath
    })
    // 如果已登录，加载头像
    if (this.isLoggedIn) {
      this.loadAvatar()
    }
  },
  methods: {
    async loadAvatar() {
      try {
        const res = await getAvatar()
        if (res.avatar_base64) {
          this.avatarBase64 = res.avatar_base64
        }
      } catch (error) {
        console.error('获取头像失败:', error)
      }
    },
    onToggleSidebar() {
      // 组件内部已经提交mutation，这里可以做额外处理
    },
    onHeaderCommand(command) {
      // 组件内部已经处理路由，这里可以做额外处理
    },
    onMenuSelect(index) {
      // 组件内部已经处理路由，这里可以做额外处理
    }
  }
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body, #app {
  width: 100%;
  height: 100%;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
}

.app-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* 主内容区域 */
.app-main {
  flex: 1;
  display: flex;
  overflow: hidden;
}

/* 主内容区 */
.app-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: var(--bg-page, #f5f7fa);
  overflow: hidden;
}

.content-container {
  flex: 1;
  overflow-y: auto;
}

/* 底部Footer */
.app-footer {
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 12px;
  color: var(--text-secondary, #909399);
  background-color: var(--bg-card, #ffffff);
  border-top: 1px solid var(--border-light, #e4e7ed);
}
</style>
